import Embed from './Embed'

export default Embed
// eslint-disable-next-line import/export
export * from './Embed'
